import DetailFormHead from "components/subHead/detailFormHead";
import { useGetData } from "./service";
import TableRow from "components/rows/tableRow";
import { dateFormat } from "components/utils/comm";
import Cell from "components/rows/cell";
import { useTranslation } from "react-i18next";
import BaseInfLoaing from "components/detailLoading/baseInf";

export default function UserDetail() {
  const { t } = useTranslation();
  const { userInf } = useGetData();

  const uYn =
    userInf?.soYn === "Y" ? "탈퇴" : userInf?.lckYn === "Y" ? "휴면" : "승인";
  return (
    <>
      {/* 기본정보 */}
      <DetailFormHead title={"회원상세"} />
      {!userInf && <BaseInfLoaing rowTitle={"회원정보"} />}
      {userInf && (
        <table>
          <tbody>
            <TableRow title={"회원정보"}>
              <ul>
                <li>
                  <Cell label={t("lbl_mem_no_cmm")} value={userInf?.memNo} />
                </li>
                <li>
                  <Cell label={t("lbl_en_fsnm_cmm")} value={userInf.memFstnm} />
                </li>
                <li>
                  <Cell
                    label={t("lbl_en_sfnm_cmm")}
                    value={userInf?.memSurnm}
                  />
                </li>
                <li>
                  <Cell label={t("lbl_sns_cmm")} value={""} />
                </li>
                <li>
                  <Cell label={t("lbl_eml_id_cmm")} value={userInf.emlId} />
                </li>
                <li>
                  <Cell
                    label={t("lbl_user_nm_cmm")}
                    value={userInf.memSurnm + userInf.memFstnm}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_country_no_cmm")}
                    value={userInf.mobCntyCd}
                  />
                </li>
                <li>
                  <Cell label={t("lbl_phone_cmm")} value={userInf.mobNo} />
                </li>
                <li>
                  <Cell label={t("lbl_lng_cmm")} value={userInf.langCd} />
                </li>
                <li>
                  <Cell label={t("lbl_crr_cmm")} value={userInf.currCd} />
                </li>
                <li>
                  <Cell label={t("lbl_stt_cmm")} value={uYn} />
                </li>
                <li>
                  <Cell
                    label={t("lbl_joined_dt_cmm")}
                    value={dateFormat(userInf?.joiDtti?.slice(0, 8) ?? "", "-")}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_deleted_dt_cmm")}
                    value={dateFormat(userInf?.lckDtti ?? "", "-")}
                  />
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      )}
    </>
  );
}
